import { Card, Space, Typography } from "antd";

import { UserForm } from "../components/UserForm";

const { Title } = Typography;

const CreateUser = () => {
  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Create User Account
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          User Information
        </Title>

        <UserForm mode="create" />
      </Card>
    </Space>
  );
};

export default CreateUser;
